import React from 'react';
import { Route, Switch } from 'react-router-dom';
import * as Unauth from '../../unauth/';

const PackagesLayout: React.FC<{}> = () => {
    return (
        <React.Fragment>
            <Switch>
                <Route render={() => <Unauth.Packages />} />
            </Switch>
        </React.Fragment>
    );
};

export default PackagesLayout;
